export const RECEIVE_USER_REVISIONS = 'RECEIVE_USER_REVISIONS';
